export default {
    'categories.activities': 'Aktivitäten',
    'categories.animals-nature': 'Tiere & Natur',
    'categories.custom': 'Benutzerdefiniert',
    'categories.flags': 'Flaggen',
    'categories.food-drink': 'Essen & Trinken',
    'categories.objects': 'Gegenstände',
    'categories.people-body': 'Mensch & Körper',
    'categories.recents': 'Zuletzt genutzt',
    'categories.smileys-emotion': 'Smileys & Emotionen',
    'categories.symbols': 'Symbole',
    'categories.travel-places': 'Reisen & Orte',
    'error.load': 'Emojis wurden nicht geladen',
    'recents.clear': 'Zuletzt genutzte Emojis löschen',
    'recents.none': 'Kein Emoji ausgewählt.',
    'retry': 'Erneut versuchen',
    'search.clear': 'Suche löschen',
    'search.error': 'Suche erfolglos',
    'search.notFound': 'Kein Emoji gefunden',
    'search': 'Emojis durchsuchen ...'
  };
  